import { Component, inject } from '@angular/core';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';

import { MaskService } from '../../services/mask.service';
import { MaskitoDirective } from '@maskito/angular';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-calculate-cost-value-dialog',
  templateUrl: './calculate-cost-value-dialog.component.html',
  styleUrls: ['./calculate-cost-value-dialog.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MaskitoDirective,
    MatDialogModule,
    MatButtonModule,
  ],
})
export class CalculateCostValueDialogComponent {
  private mask = inject(MaskService);
  private dialogRef =
    inject<MatDialogRef<CalculateCostValueDialogComponent>>(MatDialogRef);

  investmentForm: FormGroup;
  dollarMask = this.mask.dollarMaskSpecs();
  percentMask = this.mask.percentMaskSpecs();
  timeHorizonOptions: number[] = Array.from({ length: 20 }, (_, i) => i + 1);
  shareClassTimeOptions: number[] = [6];
  orderByOptions: { value: string; label: string }[] = [
    { value: 'TotalEstimatedCost', label: 'Total Estimated Cost' },
    { value: 'EstimatedFutureValue', label: 'Future Value' },
  ];

  constructor() {
    const formGroup = {};
    formGroup['investmentAmount'] = new FormControl('', Validators.required);
    formGroup['rateOfReturn'] = new FormControl('', Validators.required);
    formGroup['timeHorizon'] = new FormControl('', Validators.required);
    formGroup['conversionTimeFrame'] = new FormControl(6, Validators.required);
    formGroup['orderBy'] = new FormControl('', Validators.required);
    this.investmentForm = new UntypedFormGroup(formGroup);
    // conversion time frame to be greyed out for now
    this.investmentForm.controls['conversionTimeFrame'].disable();
  }

  calcIsDisabled(): boolean {
    if (this.investmentForm.invalid) {
      return true;
    }
    return false;
  }

  submit(): void {
    const submitData = this.investmentForm.getRawValue();
    for (const key in submitData) {
      if (typeof submitData[key] === 'string') {
        if (submitData[key].includes('$')) {
          submitData[key] = this.mask.removeMoneyMask(submitData[key]);
        } else if (submitData[key].includes('%')) {
          submitData[key] = this.mask.removePercentMask(submitData[key]);
        }
      }
    }
    this.dialogRef.close(submitData);
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  close(): void {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
